import { useEffect, useState } from "react";

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        const response = await fetch("https://www.google.com/favicon.ico", {
          method: "HEAD",
          mode: "no-cors",
        });
        setIsOnline(response.ok || navigator.onLine);
      } catch {
        setIsOnline(false);
      }
    };

    const updateOnlineStatus = () => {
      checkConnection();
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", () => setIsOnline(false));

    checkConnection();

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", () => setIsOnline(false));
    };
  }, []);

  return { isOnline };
};
